import styled from "@emotion/styled";
import { Checkbox } from "@mui/material";
import { useField } from "formik";
import TextSimple from "../../typography/text-simple/TextSimple";
interface CheckFieldProps {
  name: string;
  label?: string;
  colorLabel?: "blue" | "gray";
  onChange?: (value: boolean, name?: string) => void;
  useFormik?: boolean;
  value?: boolean;
  disabled?: boolean;
}
function CheckField(props: CheckFieldProps) {
  return props.useFormik ? (
    <CheckFieldWithFormik {...props} />
  ) : (
    <CheckFieldNormal {...props} />
  );
}
export default CheckField;
const Content = styled.div`
  width: 100%;
  height: 30px;
  display: flex;
  justify-content: center;
  flex-direction: column;
`;

const CheckFieldWithFormik = (props: CheckFieldProps) => {
  const [field, meta, helper] = useField({ name: props.name });

  const onchange = (e: React.ChangeEvent<HTMLInputElement>) => {
    helper.setValue(e.target.checked);
    props.onChange && props.onChange(e.target.checked, props?.name);
  };

  return (
    <Content>
      <div>
        <Checkbox onChange={onchange} checked={field.value} />
        <TextSimple
          color={props.colorLabel ?? "gray"}
          size="label"
          weight="500"
        >
          {props.label}
        </TextSimple>
      </div>
      {meta.touched && meta.error ? (
        <TextSimple color="red" size="description" weight="300">
          {meta.error}
        </TextSimple>
      ) : null}
    </Content>
  );
};

const CheckFieldNormal = (props: CheckFieldProps) => {
  const onchange = (e: React.ChangeEvent<HTMLInputElement>) => {
    props.onChange && props.onChange(e.target.checked, props?.name);
  };
  return (
    <Content>
      <div>
        <Checkbox onChange={onchange} checked={props.value} />
        <TextSimple
          color={props.colorLabel ?? "gray"}
          size="label"
          weight="500"
        >
          {props.label}
        </TextSimple>
      </div>
    </Content>
  );
};
